import {
  AssessmentBehaviors,
  AssessmentPragmaPower,
  Score,
} from '@app/interface/valoration-last-assessment.interface';

export function generatePragmaPowerMock(
  count: number,
  startId = 1,
  includeScores = true
): AssessmentPragmaPower[] {
  const pragmas: AssessmentPragmaPower[] = [];

  for (let i = 0; i < count; i++) {
    const id = startId + i;
    pragmas.push({
      pragmapower_id: id,
      pragmapower_name: `PragmaPower_${id}`,
      pragmapower_type_id: 1,
      pragmapower_type_name: 'Technical',
      pragmapower_description: null,
      behaviours: generateBehavioursMock(1, id * 10, includeScores),
    });
  }

  return pragmas;
}

export function generateBehavioursMock(
  count: number,
  startId = 1,
  includeScores = true
): AssessmentBehaviors[] {
  const behaviours: AssessmentBehaviors[] = [];

  for (let i = 0; i < count; i++) {
    const id = startId + i;
    behaviours.push({
      weight: i === 0 ? 2 : 1,
      position: i + 1,
      behaviour_id: id,
      behaviour_name: `Behaviour_${id}`,
      behaviour_description: `Descripción del behaviour ${id}`,
      specific_scores: includeScores
        ? generateSpecificScoresMock(2, id * 100)
        : [],
      assessment_behaviour_id: id * 10,
      response_valoration_behaviour_id: id * 20,
      response_behaviour_evaluated: false,
    });
  }

  return behaviours;
}

export function generateSpecificScoresMock(
  count: number,
  startId = 1
): Score[] {
  const scores: Score[] = [];

  for (let i = 0; i < count; i++) {
    const id = startId + i;
    scores.push({
      score_id: id,
      is_default: 1,
      score_name: `score_name_${id}`,
      score_value: Number(i.toFixed(1)),
      score_scale_id: null,
      score_scale_name: null,
      score_description: null,
      score_scale_description: null,
    });
  }

  return scores;
}
